import { render } from "./RepportTicketIncome.vue?vue&type=template&id=01f608d2&scoped=true&ts=true"
import script from "./RepportTicketIncome.vue?vue&type=script&lang=ts"
export * from "./RepportTicketIncome.vue?vue&type=script&lang=ts"

import "./RepportTicketIncome.vue?vue&type=style&index=0&id=01f608d2&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f608d2"]])

export default __exports__